<template>
  <div>
    <AddBlueprint v-on:add-blueprint="addBlueprint"></addBlueprint>
    <v-toolbar-title>{{$t("blueprints")}}</v-toolbar-title>
    <v-data-table
      :headers="headers"
      :items="blueprints"
      class="elevation-1"
      v-bind:rows-per-page-items="$store.state.rows"
    >
      <template v-slot:items="props">
        <td @click="blueprintDetails(props.item.id)">{{ props.item.name }}</td>
        <td @click="blueprintDetails(props.item.id)">{{ props.item.description }}</td>
        <td @click="blueprintDetails(props.item.id)">{{ props.item.markerName }}</td>
        <td @click="blueprintDetails(props.item.id)">{{ props.item.order }}</td>
        <td><v-icon @click="deleteBlueprint(props.item.id)">delete</v-icon></td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import AddBlueprint from "@/components/pages/Blueprints/AddBlueprint";
import { validationMixin } from 'vuelidate'

export default {
  name: "Blueprints",
  components: {
      AddBlueprint
  },
  data() {
    return {
      blueprints: [],
      headers: [
      {
        text: this.$t("name"),
        align: 'left',
        value: 'name'
      },
      {
        text: this.$t("description"),
        align: 'left',
        value: 'description'
      },
      {
        text: this.$t("markerName"),
        align: 'left',
        value: 'markerName'
      },
      {
        text: this.$t("order"),
        align: 'left',
        value: 'order'
      },
      { text: this.$t("actions"), sortable: false }
    ],
    };
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    addBlueprint(newBlueprint)
    {
        this.$http.addBlueprint(newBlueprint)
        .then(res => {
          this.blueprints.push(res.data); 
          this.$noty.success(this.$t("success"))
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    deleteBlueprint(id){
        this.$http.deleteBlueprint(id)
        this.projects = this.blueprints.filter(p => p.id != id)
    },
    blueprintDetails(id)
    {
      this.$router.push({name:'BlueprintsDetails',params:{id:id}})
    }
  },
  created() {
      this.$http.getBlueprints(this.$route.params.id)
      .then(res => (this.blueprints = res.data))
      .catch(err => console.log(err));
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Blueprints/Blueprints.vue